// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3wED9","buttons":"SendReceipts_buttons__2Qfmc","email":"SendReceipts_email__3MMvd","bookApptTitle":"SendReceipts_bookApptTitle__1OEUe"};